module.exports = __webpack_public_path__ + "static/media/bg2.1813f9d6.jpg";